import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateRange } from 'react-date-range';
import moment from 'moment';
import _ from 'lodash';

import './date_range_picker.scss';

class DateRangePicker extends Component {
  constructor(props) {
    super(props);

    this.onRangeChange = this.onRangeChange.bind(this);
  }

  onRangeChange(range) {
    const { onRangeChange } = this.props;

    if (_.isFunction(onRangeChange)) {
      const { startDate, endDate } = range;

      onRangeChange({
        dateFrom: startDate,
        dateTo: endDate,
      });
    }
  }

  render() {
    const { dateFrom, dateTo } = this.props;

    return (
      <div className="date-range-picker">
        <DateRange
          startDate={dateFrom}
          endDate={dateTo}
          onChange={this.onRangeChange}
          classNames={{
            calendar: 'date-range-picker__calendar',
            dateRange: 'date-range-picker__date-range',
            day: 'date-range-picker__day',
            days: 'date-range-picker__days',
            dayStartEdge: 'date-range-picker__day--range-start',
            dayEndEdge: 'date-range-picker__day--range-end',
            dayActive: 'date-range-picker__day--active',
            dayPassive: 'date-range-picker__day--pasive',
            dayInRange: 'date-range-picker__day--in-range',
            month: 'date-range-picker__month-year__month-value',
            monthAndYear: 'date-range-picker__month-year',
            monthAndYearWrapper: 'date-range-picker__month-year__wrapper',
            monthAndYearDivider: 'date-range-picker__month-year__divider',
            nextButton: 'date-range-picker__month-year__button-next',
            prevButton: 'date-range-picker__month-year__button-prev',
            year: 'date-range-picker__month-year__year-value',
            weekDays: 'date-range-picker__week-days',
            weekDay: 'date-range-picker__week-day',
          }}
          offsetPositive
          onlyClasses
          linkedCalendars
          twoStepChange
        />
      </div>
    );
  }
}

DateRangePicker.propTypes = {
  dateFrom: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
    PropTypes.shape({}),
  ]),
  dateTo: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.shape({})]),
  onRangeChange: PropTypes.func,
};

DateRangePicker.defaultProps = {
  dateFrom: moment().subtract(29, 'days'),
  dateTo: moment(),
  onRangeChange: () => {},
};

export default DateRangePicker;
